import { Module } from 'vuex';
import { MultifactorAuthState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: MultifactorAuthState = {
    lists: undefined,
    count: 0,
    details: undefined,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    hard: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    switchDevices: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    resetTimeCorrections: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    removalUsers: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const multifactorAuth: Module<MultifactorAuthState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
